import { render, staticRenderFns } from "./IpercResult.vue?vue&type=template&id=a9724620&scoped=true"
import script from "./IpercResult.vue?vue&type=script&lang=js"
export * from "./IpercResult.vue?vue&type=script&lang=js"
import style0 from "./IpercResult.vue?vue&type=style&index=0&id=a9724620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9724620",
  null
  
)

export default component.exports